import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_CATEGORY,
  SET_CATEGORIES,
  SET_NEW_CATEGORY_ID,
} from 'store/actions/categories';
import { addIdPrefix } from 'services/common';

const initialState = {
  categories: [],
  newCategoryId: -1,
  isFetching: false,
  error: '',
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setCategory = (state, { category }) =>
  state.merge({
    categories: state.categories.map(p =>
      p.id === category.id ? category : p,
    ),
  });

const setCategories = (state, { categories }) => state.merge({ categories });

const setNewCategoryId = (state, { newCategoryId }) =>
  state.merge({ newCategoryId });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_CATEGORY]: setCategory,
  [SET_CATEGORIES]: setCategories,
  [SET_NEW_CATEGORY_ID]: setNewCategoryId,
};

export default createReducer(initialState, handlers);
